import {doGET, shopRestBackendBaseUrl} from './mydummen.fetch.service';

export type RelatedCustomer = {
	accountRole: string | null;
	companyId: string;
	customerId: string;
	name: string;
	documentLanguage: string;
	id: string;
	lastSyncData: string | null;
	active: boolean;
}

const CUSTOMER_REST_BACKEND_BASE = `${shopRestBackendBaseUrl}/secured/app/customers`;
const LINKED_CUSTOMERS_ENDPOINT = `${CUSTOMER_REST_BACKEND_BASE}/customer-mappings`;

// Explicit type for the UntypedStore value. This way we know it was intended to be any. In this code
// we can't type the store sadly.
type UntypedStore = any;

export const getRelatedCustomersForMasterOrSalesRep = async (store: UntypedStore) => {
	const useStore = store;

	if (useStore.relatedCustomers.length > 0) {
		return;
	}

	const response = await doGET(LINKED_CUSTOMERS_ENDPOINT);
	const data = await response.json();

	useStore.setRelatedCustomers(data as RelatedCustomer[]);
};
